import Vue from 'vue'
import Router from 'vue-router'
import { weixinAppId, BASEPATH } from "@/config";
import * as MutationTypes from '../store/mutation-types'
import wechatAuth from '.././plugins/wechatAuth' // 微信登录插件
import NProgress from 'nprogress'
import { setTitle } from '@/lib/util'
import Home from "../pages/tabs/Home";
import NewWordBook from "../pages/tabs/NewWordBook"
import My from "../pages/tabs/Mine";
import Record from "../pages/tabs/Record";

import ChageRecord from "../pages/tabs/Mine/ChageRecord";
import BuyRecord from "../pages/tabs/Mine/BuyRecord";
import AddressInfo from "../pages/tabs/Mine/AddressInfo";
import ChangeSuccess from "../pages/tabs/Mine/ChangeSuccess";


// import ArticleDetail from "../pages/articleDetail/ArticleDetail";
// import ArticleQuiz from "../pages/articleQuiz/ArticleQuiz";
// import AnswerAnalysis from "../pages/answerAnalysis/AnswerAnalysis";
// import IntensiveReading from "../pages/intensiveReading/IntensiveReading";
import Payment from "../pages/pay/Payment";
import PayPage from "../pages/pay/PayPage";
import NotWeixin from "../pages/notWeixin/notWeixin";
import GoodsUrlPage from "../pages/tabs/ScoreShop/GoodsUrlPage";
import GoodsDetail from "../pages/tabs/ScoreShop/GoodsDetail";
import ScoreShop from "../pages/tabs/ScoreShop";

// import WordPreheating from "../pages/wordPreheating/WordPreheating";


import BindParent from "../pages/family/BindParent";
import BindChild from "../pages/family/BindChild";
import RelationShip from "../pages/family/RelationShip"
import ScanAddChild from "../pages/family/ScanAddChild";
import ScanAddParent from "../pages/family/ScanAddParent";
import FamilyChild from "../pages/family/FamilyChild";
import FamilyParent from "../pages/family/FamilyParent";
import BindSetup from "../pages/family/BindSetup";
import ChildReadDetail from "../pages/family/ChildReadDetail";
import Payvip from "../pages/pay/Payvip";
import ParentPayReocord from "../pages/family/ParentPayReocord";
import FreeHaibao from "../pages/share/FreeHaibao";
import LansiPayPage from "../pages/pay/LansiPayPage";
import MoreArticle from "../pages/tabs/Home/MoreArticle"
import ArticleGuidePage from "../pages/article/ArticleGuidePage"
import VoteShare from "../pages/share/VoteShare"
import ReadingPage from "../pages/article/ReadingPage"
import AnswerPage from "../pages/article/AnswerPage"
import AnswerResultPage from "../pages/article/AnswerResultPage"


import DailyReport from "../pages/share/DailyReport";

import ReadArticleHaibao from "../pages/share/ReadArticleHaibao";

// import StudyReport from "../pages/studyReport/StudyReport";
// import SelfPoster from "../pages/haibao/SelfPoster";
import GuideQrCode from "../pages/constant/guideQrCode";
// import WeeklyReport from "../pages/weeklyReport";
// // import WeeklyReportPoster from "../pages/weeklyReport/poster";

// import ReadingCampHome from "../pages/readingCamp";
// import ThemeHome from "../pages/themeReading/article/ArticleVideo";
// import ThemeArticleDetail from "../pages/themeReading/article/ArticleDetail";
// import ThemeArticleQuiz from "../pages/themeReading/article/ArticleQuiz";
// import ThemeAnswerAnalysis from "../pages/themeReading/article/ArticleAnalysis";
// import WeeklyReportPoster from "../pages/haibao/WeeklyReport";
// import ThemeArticleList from "../pages/themeReading/articleList"
// import ThemeReadingHome from "../pages/themeReading/homepage"
import MyCollect from '../pages/tabs/Mine/MyCollect'

const qs = require('qs')

Vue.use(Router)


export const constantRoutes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/record',
        name: 'Record',
        component: Record,
        meta: {
            title: '阅读打卡',
            keepAlive: true,
            showTab: true,
        }
    },
    {
        path: '/my',
        name: 'My',
        component: My,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true,
            showTab: true,
        }
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true,
            showTab: true,
            needAttent: true,
        }
    },

    {
        path: '/scoreShop',
        name: 'ScoreShop',
        component: ScoreShop,
        meta: {
            title: '积分商城',
            keepAlive: true,
            showTab: true,
        }
    },
    {
        path: '/newWordBook',
        name: 'NewWordBook',
        component: NewWordBook,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true,
            // showTab: true,
        }
    },
    {
        path: '/moreArticle',
        name: 'MoreArticle',
        component: MoreArticle,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true,
            // showTab: true,
        }
    },
    {
        path: '/articleGuide',
        name: 'ArticleGuidePage',
        component: ArticleGuidePage,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: false,
            // showTab: true,
        }
    },
    {
        path: '/readingPage',
        name: 'ReadingPage',
        component: ReadingPage,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },
    {
        path: '/answerPage',
        name: 'AnswerPage',
        component: AnswerPage,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },
    {
        path: '/answerResultPage',
        name: 'AnswerResultPage',
        component: AnswerResultPage,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },
    {
        path: '/share/dailyReport',
        name: 'DailyReport',
        component: DailyReport,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },

    {
        path: '/buyRecord',
        name: 'BuyRecord',
        component: BuyRecord,
        meta: {
            title: '我的购买',
            keepAlive: true,
        }
    },
    {
        path: '/goodsDetail',
        name: 'GoodsDetail',
        component: GoodsDetail,
        meta: {
            title: '商品详情',
            keepAlive: true,
        }
    },
    {
        path: '/addressInfo',
        name: 'AddressInfo',
        component: AddressInfo,
        meta: {
            title: '收货信息',
            keepAlive: true,
        }
    },
    {
        path: '/changeSuccess',
        name: 'ChangeSuccess',
        component: ChangeSuccess,
        meta: {
            title: '兑换成功',
            keepAlive: true,
        }
    },
    {
        path: '/chageRecord',
        name: 'ChageRecord',
        component: ChageRecord,
        meta: {
            title: '兑换记录',
            keepAlive: true,
        }
    },
    {
        path: '/payPage',
        name: 'PayPage',
        component: PayPage,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true,
        }
    },
    {
        path: '/notWeixin',
        name: 'NotWeixin',
        component: NotWeixin,
        meta: {
            requiresAuth: 'false',
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },
    {
        path: '/goodsUrlPage',
        name: 'GoodsUrlPage',
        component: GoodsUrlPage,
        meta: {
            title: '积分商城',
            keepAlive: true
        }
    },

    {
        path: '/relationShip',
        name: 'RelationShip',
        component: RelationShip,
        meta: {
            title: '亲情账号',
            keepAlive: true,
        }
    },
    {
        path: '/bindParent',
        name: 'bindParent',
        component: BindParent,
        meta: {
            title: '亲情账号',
            keepAlive: true,
        }
    },
    {
        path: '/bindChild',
        name: 'bindChild',
        component: BindChild,
        meta: {
            title: '亲情账号',
            keepAlive: true,
        }
    },
    {
        path: '/scanAddChild',
        name: 'scanAddChild',
        component: ScanAddChild,
        meta: {
            title: '亲情账号',
            keepAlive: true
        }
    },
    {
        path: '/scanAddParent',
        name: 'scanAddParent',
        component: ScanAddParent,
        meta: {
            title: '亲情账号',
            keepAlive: true
        }
    },
    {
        path: '/familyChild',
        name: 'familyChild',
        component: FamilyChild,
        meta: {
            title: '亲情账号',
            keepAlive: true,
        }
    },
    {
        path: '/familyParent',
        name: 'familyParent',
        component: FamilyParent,
        meta: {
            title: '亲情账号',
            keepAlive: true,
        }
    },
    {
        path: '/bindSetup',
        name: 'bindSetup',
        component: BindSetup,
        meta: {
            title: '绑定设置',
            keepAlive: true
        }
    },
    {
        path: '/childReadDetail',
        name: 'childReadDetail',
        component: ChildReadDetail,
        meta: {
            title: '阅读日历',
            keepAlive: false
        }
    },
    {
        path: '/payvip',
        name: 'payvip',
        component: Payvip,
        meta: {
            title: '会员天数购买',
            keepAlive: true
        }
    },
    {
        path: '/payment',
        name: 'payment',
        component: Payment,
        meta: {
            title: '会员卡',
            keepAlive: true
        }
    },
    {
        path: '/parentPayReocord',
        name: 'parentPayReocord',
        component: ParentPayReocord,
        meta: {
            title: '账户充值记录',
            keepAlive: true
        }
    },



    {
        path: '/lansiPayPage',
        name: 'lansiPayPage',
        component: LansiPayPage,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },

    {
        path: '/share/voteShare',
        name: 'VoteShare',
        component: VoteShare,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },
    {
        path: '/share/ReadArticleHaibao',
        name: 'ReadArticleHaibao',
        component: ReadArticleHaibao,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },
    {
        path: '/share/freeHaibao',
        name: 'FreeHaibao',
        component: FreeHaibao,
        meta: {
            title: '蓝思原版分级阅读',
            keepAlive: true
        }
    },
    {
        path: '/guideQrCode',
        name: 'GuideQrCode',
        component: GuideQrCode,
        meta: {
            title: '领取更多会员权益',
            keepAlive: true
        }
    },
    {
        path: '/collect',
        name: 'MyCollect',
        component: MyCollect,
        meta: {
            title: '收藏',
            keepAlive: true,
            // showTab: true,
        }
    },
]


const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    mode: 'history',
    base: BASEPATH,
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router



//////////////////
// WEBPACK FOOTER
// ./app/router/index.js
// module id = null
// module chunks = 